import { useEffect, useState, React } from "react";

import axios from "axios";
import { useAuthContext } from "../../../Hooks/useAuthContext";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Libraries
import { Form, InputGroup } from "react-bootstrap";


export default function EditOrderItemsTable({ orderItems, setOrderItems, supplier }) {
    const navigate = useNavigate()


    const [products, setProducts] = useState([]);
    //const [orderItems, setOrderItems] = useState([{
    //    productCode: "A1001",
    //    description: "Premium Cattle Feed",
    //    quantityOrdered: 10,
    //    quantityDelivered: 8,
    //    haulageRate: 10,
    //    costPrice: 139.99,
    //    salePrice: 179.99,
    //    deleted: false
    //}]);
   
    const { user } = useAuthContext();


    const handleInputChange = (index, field, value) => {
        if (field == "productCode") {
            // find the product that was selected
            var selectedProduct = products.find((product) => product.code == value);


            const updatedItems = orderItems.map((item, i) =>
                i === index ? {
                    ...item,
                    ["productCode"]: value,
                    ["productName"]: selectedProduct.name,
                    ["haulageRate"]: selectedProduct.haulageRate,
                    ["costPrice"]: selectedProduct.costPrice,
                    ["agentCostPrice"]: selectedProduct.costPrice,
                    ["salePrice"]: selectedProduct.salePrice,
                } : item
            );
            setOrderItems("orderItems", updatedItems);
        }
        else {

            const updatedItems = orderItems.map((item, i) =>
                i === index ? {
                    ...item,
                    [field]: value,
                } : item
            );
            setOrderItems("orderItems", updatedItems);
        }
    };

    const handleAddRow = () => {
        setOrderItems("orderItems", [...orderItems, { productCode: "0", deleted: false }]);
    }

    useEffect(() => {
        // Load products
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/products/?supplierId=${supplier}`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                if (res.status === 200) {
                    setProducts(res.data.data);
                }
            })
    }, [supplier])

   

  
    

    return (
        <div style={{marginBottom: 40}}>
            <table style={{width:"100%", marginBottom: 10}}>
                <thead>
                    <tr>
                        <th>Product</th>
                        <th style={{ width: 100 }}>Qty<br />Ordered</th>
                        <th style={{ width: 100 }}>Qty<br />Del.</th>
                        <th style={{ width: 150 }}>Haulage Rate</th>
                        <th style={{ width: 150 }}>AFS<br/> Cost Price</th>
                        <th style={{ width: 150 }}>Agent<br/> Cost Price</th>
                        <th style={{ width: 150 }}>Sale Price</th>
                        <th style={{ width: 50 }}>&nbsp;</th>
                    </tr>
                </thead>

                <tbody>
                    {orderItems && orderItems.map((item, index) => (

                        <tr style={{display: item.deleted ? "none": ""}} key="index">
                            {/* Product Code / Item Description */}
                            <td>
                                <div className="select">
                                    <Form.Select
                                        onChange={e => handleInputChange(index, 'productCode', e.target.value)}
                                        value={item.productCode}
                                    >
                                        <option value="0" disabled>Please Select...</option>
                                        {products && (products.map((product) => {
                                            return <option key={product.id} value={product.code}>{product.name} {product.code && ('(' + product.code + ')')}</option>
                                        }))}
                                    </Form.Select>
                                </div>
                            </td>
                            {/* Quantity Ordered */}
                            <td>
                                <Form.Control
                                    type="text"
                                    value={item.quantityOrdered}
                                    onChange={e => handleInputChange(index, 'quantityOrdered', e.target.value)}
                                />
                            </td>
                            {/* Quantity Delivered */}
                            <td>
                                <Form.Control
                                    type="text"
                                    value={item.quantityDelivered}
                                    onChange={e => handleInputChange(index, 'quantityDelivered', e.target.value)}
                                />
                            </td>
                            {/* Haulage Rate */}
                            <td>
                                <InputGroup>
                                    <InputGroup.Text>&pound;</InputGroup.Text> {/* Prefix */}
                                    <Form.Control
                                        type="text"
                                        value={item.haulageRate}
                                        onChange={e => handleInputChange(index, 'haulageRate', e.target.value)}
                                    />
                                </InputGroup>
                            </td>
                            {/* Cost Price */}
                            <td>
                                <InputGroup>
                                    <InputGroup.Text>&pound;</InputGroup.Text> {/* Prefix */}
                                    <Form.Control
                                        type="text"
                                        value={item.costPrice}
                                        onChange={e => handleInputChange(index, 'costPrice', e.target.value)}
                                    />
                                </InputGroup>
                            </td>
                            {/* Agent Cost Price */}
                            <td>
                                <InputGroup>
                                    <InputGroup.Text>&pound;</InputGroup.Text> {/* Prefix */}
                                    <Form.Control
                                        type="text"
                                        value={item.agentCostPrice}
                                        onChange={e => handleInputChange(index, 'agentCostPrice', e.target.value)}
                                    />
                                </InputGroup>
                            </td>
                            {/* Sale Price */}
                            <td>
                                <InputGroup>
                                    <InputGroup.Text>&pound;</InputGroup.Text> {/* Prefix */}
                                    <Form.Control
                                        type="text"
                                        value={item.salePrice}
                                        onChange={e => handleInputChange(index, 'salePrice', e.target.value)}
                                    />
                                </InputGroup>
                            </td>
                            
                            <td><button type="button" className="btn btn-other" onClick={() => { handleInputChange(index, 'deleted', true) }}>X</button></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button type="button" className="btn btn-primary" onClick={handleAddRow}>Add Item</button>
        </div>
    )
}
